/* eslint-disable max-len */
import { PureComponent } from 'react';
/** @namespace Bodypwa/Component/ReloadIcon/Component */

export class ReloadIconComponent extends PureComponent {
    render() {
        return (
            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75 2.75C12.2018 2.75 15 5.54822 15 9H12L16 14L20 9H17.5C17.5 4.16751 13.5825 0.25 8.75 0.25C3.91751 0.25 0 4.16751 0 9C0 13.8325 3.91751 17.75 8.75 17.75C10.9056 17.75 12.8792 16.9705 14.4042 15.678L12.8416 13.7247C11.7452 14.675 10.3148 15.25 8.75 15.25C5.29822 15.25 2.5 12.4518 2.5 9C2.5 5.54822 5.29822 2.75 8.75 2.75Z" fill="#070707" />
            </svg>
        );
    }
}

export default ReloadIconComponent;
